import Ticket from "./components/Ticket";

export default Ticket